module.exports = __webpack_public_path__ + "img/36_30.681bdc2e.png";